import { resolveAvatarUrl } from '@/utils/avatar';
import { resolveAssetUrl } from '@/utils/assets';

const medalIcons = { 1: '1', 2: '2', 3: '3' };

const rarityColors = {
  common: 'border-edge bg-surfaceAlt',
  rare: 'border-ocean-light/50 bg-ocean-light/15',
  epic: 'border-gem/50 bg-gem/15',
  legendary: 'border-accent/70 bg-accent/20',
};

function BadgePip({ badge }) {
  const colorClass = rarityColors[badge.rarity] || rarityColors.common;
  return (
    <div
      title={badge.name}
      className={`h-8 w-8 flex-shrink-0 overflow-hidden rounded-full border-2 ${colorClass} grid place-items-center`}
    >
      {badge.imageUrl
        ? <img src={resolveAssetUrl(badge.imageUrl)} alt={badge.name} className="h-full w-full object-cover" />
        : <span className="text-[10px] font-black text-fg/80">
            {badge.name?.slice(0, 2).toUpperCase() || '??'}
          </span>
      }
    </div>
  );
}

export default function AchievementRankingCard({ entry, isMe }) {
  const rank = entry.rank;

  return (
    <div className={`rounded-2xl border p-3 transition-all ${
      isMe ? 'border-accent bg-accent/10' : 'border-edge bg-surface'
    }`}>
      <div className="flex items-center gap-3">
        <div className="w-8 text-center font-urban font-bold text-lg flex-shrink-0 text-fg">
          {medalIcons[rank] || <span className="text-muted text-base">#{rank}</span>}
        </div>

        <div className="h-10 w-10 flex-shrink-0 overflow-hidden rounded-full border-2 border-accent/30 bg-surfaceAlt grid place-items-center">
          {entry.player?.avatarUrl
            ? <img src={resolveAvatarUrl(entry.player.avatarUrl)} alt="Avatar" className="h-full w-full object-cover" />
            : <span className="text-xl">HC</span>
          }
        </div>

        <div className="flex-1 min-w-0">
          <div className={`font-body font-bold text-sm truncate ${isMe ? 'text-accent' : 'text-fg'}`}>
            {entry.player?.displayName || entry.player?.username}
          </div>
          <div className="text-xs text-muted">Nivel {entry.player?.level}</div>
        </div>

        <div className="text-right flex-shrink-0">
          <div className="font-urban font-bold text-accent text-base">{entry.score}</div>
          <div className="text-[10px] text-muted">pts</div>
        </div>
      </div>

      <div className="mt-2 flex items-center gap-2 pl-11">
        <div className="flex gap-1">
          {entry.featuredBadges?.length > 0
            ? entry.featuredBadges.map((badge) => <BadgePip key={badge.id} badge={badge} />)
            : <span className="text-xs text-muted italic">Sem conquistas</span>
          }
        </div>
        <div className="ml-auto flex gap-3 text-[10px] text-muted">
          {entry.badgeCount > 0 && (
            <span><span className="font-black text-fg/70">{entry.badgeCount}</span> medalhas</span>
          )}
          {entry.rarePlus > 0 && (
            <span><span className="font-black text-gem">{entry.rarePlus}</span> raras+</span>
          )}
          {entry.zoneConquests > 0 && (
            <span><span className="font-black text-accent">{entry.zoneConquests}</span> zonas</span>
          )}
        </div>
      </div>
    </div>
  );
}
